module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#facebook",
      toString: function () {
        return this.url;
      }
    }